// Remove caracteres de controle não-imprimíveis (ex.: U+0013/DC3) que "viajam"
// em textos colados de outros sistemas e quebram a tela de registro de contato do MV.
// Preserva tab (\t), quebras de linha (\n, \r) e todo o conteúdo textual/markdown.
const CONTROL_CHARS_REGEX =
  // eslint-disable-next-line no-control-regex
  /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\u200B\uFEFF]/g

export const sanitizeControlChars = (value = ''): string => {
  if (!value) return ''
  return value.replace(CONTROL_CHARS_REGEX, '')
}
